import { useContext } from 'react';
import { ProductContext } from './context';

export function useProduct() {
    const context = useContext(ProductContext);

    if (!context) {
        throw new Error('useProduct must be used within the ProductProvider');
    }

    return context;
}
